export default "__VITE_PUBLIC_ASSET__626265cd__"